document.addEventListener("DOMContentLoaded", function () {

    // swiper výpis nemovitostí
    //=========================
    (function () {
        let swiperSelector = document.querySelector('[data-reviews-swiper]');
        if (typeof (swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let reviewsSwiper = new Swiper(swiperSelector, {
            effect: 'fade',
            pagination: {
                el: '.swiper-reviews-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
                delay: 10000,
            },
            loop: true,
        });

    }());
});